import React, { useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import HeaderBox from "../../reuseableComponents/headerBox/HeaderBox";
import { UserContext } from "../../reuseableComponents/auth/UserContext";
import UserProfileFavoriteReportsForm from "./UserProfileFavoriteReportsForm";
import UserProfileSdwisReportsForm from "./UserProfileSdwisReportsForm";

const UserProfilePage = (props) => {
  const { user } = useContext(UserContext);

  return (
    <>
      <Row>
        <Col>
          <Link to='/' cypressid='backtoPublicLink' className='hyperlink'>
            Home
          </Link>
        </Col>
      </Row>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='userProfile'>
            <h3 style={{ color: "#fff" }}>User Profile</h3>
          </HeaderBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <>
            <h3>{user.firstName + " " + user.lastName}</h3>
            <span>{user.isSysAdmin ? <span>Waterlink System Administrator</span> : ""}</span>
            <br />
            <span>{user.isStaff ? <span>DDW Staff</span> : ""}</span>
            <br />
            <span>{user.isPortalUser ? <span>Portal User</span> : ""}</span>
            <br />
          </>
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>Roles & Permissions</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          {user.assignments.length === 0 ? (
            <span>
              You have not been granted access to any modules. Contact the system administrator for more details.
            </span>
          ) : (
            user.assignments.map((role) => (
              <span key={role.moduleCode}>
                <b>Module:</b> {role.moduleAssigned} <b className='ms-3'>Role: </b>
                {role.roleAssigned}
                <br />
              </span>
            ))
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <UserProfileFavoriteReportsForm umdId={user.umdId} />
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          <UserProfileSdwisReportsForm umdId={user.umdId} />
        </Col>
      </Row>
    </>
  );
};

export default UserProfilePage;
